module.exports = __webpack_public_path__ + "static/media/needs-11-outline.9531b59e.png";